var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.previewClass},[_c('article',{staticClass:"markdown-body"},[_c('VueShowdown',{attrs:{"markdown":_vm.content,"flavor":"github","options":{
        emoji: true,
        prefixHeaderId: 'rec-',
        parseImgDimensions: true,
        simplifiedAutoLink: true,
        excludeTrailingPunctuationFromURLs: true,
        strikethrough: true,
        ghMentions: false,
        smoothLivePreview: true,
      },"extensions":[_vm.extensions]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }